import React from 'react';

interface IProps {
  style?: any;
  fillColor?: string;
}

export const PreviewForm:React.FC<IProps> = (props) => {
  return (
    <svg width="174" height="150" viewBox="0 0 174 150" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="43" height="101" rx="5" fill={props.fillColor ?? "#E0E1E5"}/>
      <rect x="62" width="112" height="101" rx="5" fill={props.fillColor ?? "#E0E1E5"}/>
      <rect y="111" width="174" height="39" rx="5" fill={props.fillColor ?? "#E0E1E5"}/>
    </svg>
  )
}